import React from 'react';

import { SVGComponentProps } from './svg.types';

const CustomizeSVG = ({
  size = '1em',
  fill = 'currentColor',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M0.310044 2.89811H2.77348V4.03285C2.77348 4.18624 2.8915 4.32423 3.05378 4.32423H4.86814C5.01569 4.32423 5.14843 4.20154 5.14843 4.03285V0.291372C5.14843 0.137989 5.03041 0 4.86814 0H3.0685C2.92095 0 2.7882 0.122685 2.7882 0.291372V1.42611H0.31007C0.133088 1.42611 0.000244141 1.57949 0.000244141 1.74818V2.56088C0.000244141 2.76014 0.147797 2.89822 0.31007 2.89822L0.310044 2.89811Z"
        fill={fill}
      />
      <path
        d="M13.7039 1.42578H6.0481V2.89789H13.6892C13.8662 2.89789 13.999 2.74451 13.999 2.57583V1.76313C14.0137 1.56375 13.8662 1.42578 13.7039 1.42578H13.7039Z"
        fill={fill}
      />
      <path
        d="M13.704 6.27148H10.9456V7.7436H13.6893C13.8662 7.7436 13.9991 7.59021 13.9991 7.42153V6.60883C14.0138 6.40946 13.8663 6.27148 13.704 6.27148H13.704Z"
        fill={fill}
      />
      <path
        d="M0.309955 7.74382H7.67076V8.87856C7.67076 9.03194 7.78878 9.16993 7.95106 9.16993H9.76542C9.91297 9.16993 10.0457 9.04724 10.0457 8.87856L10.0456 5.13708C10.0456 4.98369 9.92759 4.8457 9.76531 4.8457H7.96568C7.81812 4.8457 7.68538 4.96839 7.68538 5.13708V6.27181H0.309826C0.132844 6.27181 0 6.4252 0 6.59388V7.40658C0 7.60585 0.147553 7.74382 0.309826 7.74382H0.309955Z"
        fill={fill}
      />
      <path
        d="M13.7039 11.1172H6.0481V12.5893H13.6892C13.8662 12.5893 13.999 12.4359 13.999 12.2672V11.4545C14.0137 11.2706 13.8662 11.1172 13.7039 11.1172H13.7039Z"
        fill={fill}
      />
      <path
        d="M4.86789 9.69141H3.06826C2.9207 9.69141 2.78796 9.81409 2.78796 9.98278V11.1175L0.309826 11.1174C0.132844 11.1174 0 11.2708 0 11.4395V12.2522C0 12.4362 0.147553 12.5742 0.309826 12.5742H2.77326V13.709C2.77326 13.8624 2.89128 14.0004 3.05356 14.0004H4.86792C5.01547 14.0004 5.14822 13.8777 5.14822 13.709V9.98284C5.14822 9.81416 5.03019 9.69146 4.86792 9.69146L4.86789 9.69141Z"
        fill={fill}
      />
    </svg>
  );
};

export default CustomizeSVG;
